<template>
    <div class="header">
        <p>
            <select name="urll" class="langu" onchange="open1(this.value)">
                <option value="/">中文版</option>
                <option value="../en/index.aspx">ENGLISH</option>
            </select>
        </p>
    </div>
</template>

<script>
    export default {
        name: "Header",
        props: {
        },
        data() {
            return {
            }
        },
        mounted() {
        },
        methods: {

        },
        watch: {
        }
    }
</script>

<style lang="scss" scoped >
    .header{
        width: 1001px;
        height: 36px;
        background: url("../../assets/images/map_03.jpg") no-repeat 891px center;
        margin: 0 auto;
        position: relative;

        .p {
            display: block;
            margin-block-start: 1em;
            margin-block-end: 1em;
            margin-inline-start: 0px;
            margin-inline-end: 0px;
            unicode-bidi: isolate;


        }
        .langu {
            width: 79px;
            height: 21px;
            color: #006765;
            line-height: 21px;
            position: absolute;
            right: 0px;
            top: 7px;
            text-align: center;
        }
    }

</style>
